// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import React, { useCallback } from 'react'
import { bool, func, string } from 'prop-types'
import { useDispatch } from 'react-redux'
import { Field } from 'redux-form'
import { LabeledInput } from 'components/Form'
import Lookup from 'components/Lookup'
import { getContactLookupInitialValues } from './helpers'

// NOTE - when using this component,
// an async validation handler should be assigned to the input.

const lookupFormName = 'contact-lookup'

const Contact = props => {
  const {
    clearable,
    disabled,
    id,
    label,
    name,
    selectRow,
    sourceForm,
  } = props

  const dispatch = useDispatch()

  const getLookupTypeProps = useCallback(() => {
    const {
      initialValues,
      triggerSearchOnMount,
    } = dispatch(getContactLookupInitialValues(sourceForm, name, lookupFormName))

    const styles = {
      content: { width: 900 },
    }

    return {
      initialValues,
      styles,
      triggerSearchOnMount,
    }
  }, [sourceForm, name])

  return (
    <div className={'contact-input display-flex align-items-start width-100'}>
      <div className={'flex-child-1-0-auto'}>
        <Field
          clearable={clearable}
          component={LabeledInput}
          disabled={disabled}
          id={id}
          label={label}
          name={name}
          placeholder={''} />
      </div>
      <Lookup
        disabled={disabled}
        getLookupTypeProps={getLookupTypeProps}
        lookupFormName={lookupFormName}
        lookupLabel={'Contact Lookup'}
        lookupType={'contact'}
        selectRow={selectRow}
        triggerId={`${id}-lookup-trigger`} />
    </div>
  )
}

Contact.propTypes = {
  clearable: func.isRequired,
  disabled: bool,
  id: string.isRequired,
  label: string.isRequired,
  name: string.isRequired,
  selectRow: func.isRequired,
  sourceForm: string.isRequired,
}

export default Contact
